import React from 'react';
import { H5, P1, TextLink } from 'pfm-ui-components';

const TermsAndConditionInfo = () => {
  return (
    <React.Fragment>
      <P1>
        I/We also confirm that: I/We understand the specific risk of the investment products selected and request the
        Bank to proceed with instruction(s)/transaction(s) at my/our sole risk and responsibility.
      </P1>
      <br />
      <P1>
        I/We understand that investment products are distributed by AXIS BANK LIMITED on a non-discretionary and
        non-participation basis. Any investment related discussion is a service without any consideration by AXIS BANK
        LIMTED to the Investor and the final investment decision shall at all times exclusively remain with the
        investor. I/We confirm that the aforesaid instruction(s) are given at my discretion and I/We will not raise any
        dispute or objection on AXIS BANK LIMITED proceeding with instructions. I/We understand that in the event of
        me/us providing direct instructions to the AMC (Asset Management Company) and/or to any of their agents. AXIS
        BANK LIMITED shall not be liable / responsible in this regard for any reason whatsoever. All such transactions,
        including but not limited to the above so initiated by me/us directly with the AMC shall be at my/our sole risk
        and responsibility.
      </P1>
      <br />
      <P1>
        I/We have read the Key Information Memorandum (available on the website of the said AMC / Fund House) relevant
        to this scheme. I/We have clearly understood the key product features, including the investment objective, the
        proposed asset allocation and the associated risks to my principal investment and/or the returns from the same.
        I/We hereby confirm the transaction and request you to proceed with the transaction and process the same.
      </P1>
      <br />
      <P1>
        I/We have neither received nor been induced by any rebate or gifts, directly or indirectly in making this
        investment. This confirmation shall be deemed to be re-confirmed and be effective for every instruction for
        investment from me/us to AXIS BANK LIMTED.
      </P1>
      <br />
      <P1>
        For minor account trasanctions, OTP shall be triggered to the minor account registered mobile number as provided
        by the guardian during account opening.
      </P1>
      <br />
      <P1>
        I/We agree to abide by the Terms and Conditions, rules and regulations of the Mutual Fund Schemes and confirm
        that all the money invested in the scheme legally belongs to me/us.
      </P1>
      <br />
      <P1>
        I/We shall not hold AXIS BANK LIMTED liable on account of AXIS BANK LIMTED acting in good faith on any of my/our
        instructions. AXIS BANK LIMTED may at its discretion not carry out instruction(s) from me/us where AXIS BANK
        LIMITED has reason to believe that the instructions are not genuine or are otherwise improper or unclear or
        raise a doubt.
      </P1>
      <br />
      <P1>
        I/We shall not question or dispute this decision of AXIS BANK LIMITED. The Bank shall not be liable if any
        instructions are not carried out for any reason whatsoever and/or for any contrary instructions so provided by
        me/us to the AMC.
      </P1>
      <br />
      <P1>
        I/We accept my/our investment / transaction requests under channel partner arrangement with &#x27;Anyone or
        Survivor&#x27; mode of operations (when there is more than one holder) and same can be conveyed to the
        respective Product Providers for their execution.
      </P1>
      <br />
      <P1>
        I/We don&#x27;t have any objection on honouring my/our investment &amp; redemption request by the respective
        Product Providers received through the Axis Bank channel partner arrangement with &#x27;Anyone or Survivor&#x27;
        mode of operation ever in the mode of operation in the folio maintained in the records of the respective Product
        Providers is jointly and I/We will not hold AXIS BANK LIMTED liable for any disputes, if any raised by joint
        holders mentioned in folio.
      </P1>
      <br />
      <P1>
        I/We hereby understand and accept the above arrangement and agree to hold harmless Axis Bank and its group
        companies / subsidiaries, Product Providers, its directors, and employees at all times against any loss,
        liability, damage, cost or expenses arising out of any action undertaken or activities performed on the basis of
        above confirmation/information/documents furnished in/with this form or at time hereafter or failure to furnish
        information/document in/with this form or at any time hereafter.
      </P1>
      <br />
      <P1>
        I/We understand that Mutual Fund investments are subject to market risk, read all scheme related documents
        carefully. Axis Bank Ltd is acting as an AMFI registered MF Distributor (ARN code: ARN-0019). Visit Axis Bank
        Internet / Mobile banking platforms, MF scheme details page for more information. Purchase of Mutual Funds by
        Axis Bank’s customer is purely voluntary and not linked to availment of any other facility from the Bank. Axis
        Mutual Fund is one of the Mutual Fund house whose products are distributed by Axis Bank wherein Axis Asset
        Management Company Limited is asset manager of Axis Mutual Fund and is also subsidiary of Axis Bank Ltd. "I/We
        understand that the Scheme(s) which I/we am/are subscribing to is of ‘Regular Plan’ and involves payment of
        commission to Mutual Fund Distributor by AMCs.
      </P1>
      <br />
      <P1>
        I/We confirm that the aforesaid is execution mode only transaction done at my discretion and I/We confirm that
        the transaction executed does not require EUIN, as this transaction is executed without any interaction or
        advice by the employee/relationship manager/sales person of Axis Bank or notwithstanding the advice of
        in-appropriateness, if any, provided by the employee/relationship manager/sales person of Axis Bank.
      </P1>
      <br />
      <P1>
        An Equity Linked Saving Scheme (ELSS) is an open-ended diversified equity mutual fund. ELSS mutual funds comes
        with the dual benefit of tax deductions and wealth creation over time. These schemes have a lock-in period of
        three years. Investors can claim tax deductions of up to Rs 1.5 lacs p.a. under Sec 80C of Income Tax Act 1961.
        Investors are advised to consult their tax consultant regarding the specific amount of tax and other
        implications that may arise from their participation in ELSS.
      </P1>
      <br />
      <P1>
        Please note that we are using your details available with us (PAN, full name, mobile number and email id) to
        share with the KRAs (KYC registration agencies) for Mutual fund Know your customer (KYC) check. The data is also
        shared with AMCs (Asset Management Companies who manage your investments in mutual funds) as they need the
        information for on boarding you as a customer. There is a possibility of name, mobile number and/or email id
        mismatch between your details stored in the Bank and what is available with the KRAs. In such scenarios, the AMC
        may reject your transaction. Axis Bank will not liable for such rejection cases. As per Income Tax guidelines,
        it is mandatory to link your PAN with Aadhaar before June 30, 2023. Please do so by visiting the Income Tax
        website. Post June 30, 2023, your transactions are liable to be rejected by the AMCs in case you do not link
        Aadhaar and PAN.
      </P1>
      <br />
      <P1>
        You can refer the scheme documents Scheme Information Document(SID) / Key Information Memorandum (KIM) /
        Statement of Additional Information (SAI) for the respective AMC's by clicking on the below links
      </P1>
      <br />
      <TextLink target="_blank" href="https://mutualfund.adityabirlacapital.com/resources/forms/" tabIndex={0}>
        Aditya Birla Sun Life Mutual fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.axismf.com/downloads" tabIndex={0}>
        {' '}
        Axis Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.bajajamc.com/downloads?sid-kim-products-forms"
        tabIndex={0}
      >
        Bajaj Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.canararobeco.com/forms-downloads/forms-and-information-documents/forms/application-form"
        tabIndex={0}
      >
        Canara Robeco Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.dspim.com/investor-centre/download" tabIndex={0}>
        DSP Blackrock Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        href="https://www.edelweissmf.com/downloads/scheme-information-document-funds"
        tabIndex={0}
      >
        Edelweiss Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        href="https://www.franklintempletonindia.com/investor/downloads/fund-documents#"
        tabIndex={0}
      >
        Franklin Templeton Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.hdfcfund.com/information/online-services-investors" tabIndex={0}>
        HDFC Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        href="https://www.assetmanagement.hsbc.co.in/en/mutual-funds/investor-resources"
        tabIndex={0}
      >
        HSBC Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.icicipruamc.com/Downloads/sid-mutual-fund.aspx" tabIndex={0}>
        ICICI Prudential Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.idfcmf.com/download-centre.aspx?tab=sid" tabIndex={0}>
        Bandhan Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://invescomutualfund.com/literature-and-form?tab=Forms" tabIndex={0}>
        Invesco India Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.kotakmf.com/Information/forms-and-downloads" tabIndex={0}>
        Kotak Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.licmf.com/sid-kim-sai" tabIndex={0}>
        LIC Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.miraeassetmf.co.in/downloads/forms" tabIndex={0}>
        Mirae Asset Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.motilaloswalmf.com/downloads/mutual-fund" tabIndex={0}>
        Motilal Oswal Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        href="https://mf.nipponindiaim.com/investor-service/downloads/scheme-information-document"
        tabIndex={0}
      >
        Nippon India Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://amc.ppfas.com/downloads/index.php" tabIndex={0}>
        PPFAS Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.sbimf.com/en-us/offer-document-sid-kim" tabIndex={0}>
        SBI Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.sundarammutual.com/Downloads" tabIndex={0}>
        Sundaram Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="http://www.tatamutualfund.com/downloads/scheme-information-document" tabIndex={0}>
        TATA Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.utimf.com/forms-and-downloads/" tabIndex={0}>
        UTI Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" rel="noopener noreferrer" href="https://mf.whiteoakamc.com/downloads" tabIndex={0}>
        WHITEOAK Capital Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.mahindramanulife.com/downloads#SID/SAI"
        tabIndex={0}
      >
        Mahindra Manulife Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.360.one/asset-management/mutualfund/"
        tabIndex={0}
      >
        360 ONE Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.unionmf.com/about-us/downloads#!#sidsainotice"
        tabIndex={0}
      >
        Union Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.axisbank.com/retail/investment/mutual-funds/features-benefits"
        tabIndex={0}
      >
        Mutual Fund Commission structure
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.amfiindia.com/downloads/revised-code-conduct-of-inter-mf"
        tabIndex={0}
      >
        AMFI Code of Conduct
      </TextLink>{' '}
      <br />
      <br />
      <P1>
        "Axis Bank Ltd. is acting as Association of Mutual Funds in India (AMFI) registered Mutual Fund Distributor
        under the AMFI Registration Number (ARN) code of ARN-0019 "
      </P1>
      <br />
      {/* This Code is in compliance with Clause 49 of the Listing Agreements relating to Corporate Governance. */}
    </React.Fragment>
  );
};

export default TermsAndConditionInfo;
